import { forwardRef, useEffect, useState } from "react"
import { getter, orderBy } from "@progress/kendo-data-query";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import { Tooltip } from "@progress/kendo-react-tooltip";
import moment from "moment";
import { useLocation, useNavigate } from "react-router";
import ReadBAAModal from "./baaReadBody";
import APP_ROUTES from "src/helper/app-routes";
import NOTIFICATION_MESSAGE from "src/helper/notification-messages";
import { AnnouncementServices } from "src/services/announcementService";
import { Loader } from "@progress/kendo-react-indicators";

const DATA_ITEM_KEY = "id";
const SELECTED_FIELD = "selected";
const idGetter = getter(DATA_ITEM_KEY);
const BAAHistoryDialog = forwardRef(({
  
}, ref) => {
  const location = useLocation()
  const pageChange = (event) => {
    setPage(event.page.skip);
    setPageSize(event.page.take);
  };
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [showChanges, setShowChanges] = useState(false);


  const [sort, setSort] = useState([]);
  const navigate = useNavigate();
  const [showBaaDialog, setShowBaaDialog] = useState(false);
  const [selectedBaaBody, setSelectedBaaBody] = useState("");
  const [selectedState, setSelectedState] = useState({});
  const [announcements, setAnnouncements] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    getAnnouncements();
  }, [])

  const getAnnouncements = async () => {
    setLoading(true);
    const data = {
    };

    try {
      const result = await AnnouncementServices.get_Baa(data);
      setAnnouncements((result.resultData || []).slice(1));
    } catch (error) {
      NOTIFICATION_MESSAGE.error(error);
    } finally {
      setLoading(false);
    }
  };
  const handleOpenBaaDialog = (body) => {
    setSelectedBaaBody(body);
    setShowBaaDialog(true);
  };
  const handleCloseBaaDialog = () => {
    setShowBaaDialog(false);
    setSelectedBaaBody("");
  };
  return (
    <div>
        <button
          type="button"
          value="BACK"
          onClick={() => navigate(APP_ROUTES.BAA)}
          className="border-0 bg-transparent arrow-rotate mb-3"
          style={{ padding: "0", margin: "0" }}
        >
          <i className="fa-solid fa-arrow-left mr-2"></i> Back
        </button>
        {loading && <Loader />}
        <Grid
            data={orderBy(
              announcements.slice(page, page + pageSize),
              sort
            ).map((item) => ({
              ...item,
              [SELECTED_FIELD]: selectedState[idGetter(item)],
            }))}                  
            skip={page}
            take={pageSize}
            onPageChange={pageChange}
            total={announcements.length}
            pageable={{
              pageSizes: [10, 25, 50, 100, 250, 500],
            }}
            selectedField={SELECTED_FIELD}
            dataItemKey={DATA_ITEM_KEY}
            sort={sort}
            sortable={true}
            scrollable="none"
          >
          <GridColumn
              title="Version #"
              className="cursor-default"
              width="150px"
              cells={{
                data: (props) => {
                  let versionNumber =
                    props?.dataItem?.versionNo;
                  let actionId = props?.dataItem?.actionId;
                  return (
                    <td className="cursor-default">
                      {actionId !== 0
                        ? `v${versionNumber}`
                        : versionNumber}
                    </td>
                  );
                }
              }}
            />
                    {/* Body (50 chars + ...) */}
          <GridColumn
            title="Agreement"
            cells={{
              data: (props) => {
                const fullBody = props.dataItem?.body || "";
                const plainText = fullBody.replace(/<[^>]*>/g, "");
                const shortText =
                  plainText.length > 50
                    ? plainText.substring(0, 50)
                    : plainText;

                return (
                  <td
                    style={{cursor: 'pointer'}}
                    onClick={() => handleOpenBaaDialog(fullBody)}
                  >
                    {plainText ? (
                      <>
                        {shortText}
                          <span
                            className="text-primary cursor-pointer ms-1"
                            style={{display: 'inline-block'}}
                          >
                            <Tooltip style={{display: 'inline'}} anchorElement="target" position="top">
                              <b title="Read More">...</b>
                            </Tooltip>
                          </span>
                      </>
                    ) : (
                      "-"
                    )}
                  </td>
                );
              },
            }}
          />
          <GridColumn
              title="Added By"
              className="cursor-default"
              width="150px"
              cells={{
                data: (props) => {
                  let createdBy =
                    props?.dataItem?.createdByName;
                  return (
                    <td className="cursor-default">
                      {createdBy}
                    </td>
                  );
                }
              }}
          />
          <GridColumn
              title="Edit On"
              cells={{
              data: (props) => (
                  <td>
                  {props.dataItem?.createdDate
                      ? moment(props.dataItem.createdDate)
                          .local()
                          .format("M/D/YYYY")
                      : "-"}
                  </td>
              ),
              }}
          />

          <GridColumn
            width={120}
            title="Action"
            filterable={false}
            cells={{
              data: (props) => (
                <td>
                  <div
                    className="k-chip k-chip-md k-rounded-md k-chip-solid k-chip-solid-base icon-green"
                    onClick={() =>
                      // setShowChanges(true)
                      navigate(APP_ROUTES.ADD_BAA, {
                        state: {
                          baa: props.dataItem,
                          isEdit: false,
                          isDuplicate: true
                        },
                      })
                    }
                  >
                    <Tooltip position="top" anchorElement="target">
                      <i title="Duplicate" className="fa-solid fa-clone" />
                    </Tooltip>
                  </div>
                </td>
              ),
            }}
          />
        </Grid>
        {showBaaDialog && (
          <ReadBAAModal
            title={'Read BAA'} 
            onClose={handleCloseBaaDialog}
            message={selectedBaaBody}
          />
      )}
      </div>
    )
  
})

export default BAAHistoryDialog